<template>
  <transition
    enter-active-class="animated fadeIn"
    leave-active-class="animated fadeOut"
  >
    <div v-if="showing" :class="{ [overlayClass]: overlay }">
      <slot name="loading-container">
        <div :class="loaderClass">
          <slot name="loading-spinner">
            <b-spinner
              style="width: 4rem; height: 4rem"
              variant="primary"
            ></b-spinner>
          </slot>
          <slot name="loading-text">
            <div id="fountainTextG" class="text-position">
              <div id="fountainTextG_1" class="fountainTextG">L</div>
              <div id="fountainTextG_2" class="fountainTextG">o</div>
              <div id="fountainTextG_3" class="fountainTextG">a</div>
              <div id="fountainTextG_4" class="fountainTextG">d</div>
              <div id="fountainTextG_5" class="fountainTextG">i</div>
              <div id="fountainTextG_6" class="fountainTextG">n</div>
              <div id="fountainTextG_7" class="fountainTextG">g</div>
            </div>
          </slot>
        </div>
      </slot>
    </div>
  </transition>
</template>

<script>
import { eventBus } from "@/main.js";
export default {
  props: {
    label: {
      type: String,
      default: 'Loading...',
    },
    show: {
      type: Boolean,
      default: false,
    },
    overlay: {
      type: Boolean,
      default: true,
    },
    loaderClass: {
      type: String,
      default: 'loader-wrapper',
    },
    overlayClass: {
      type: String,
      default: 'white-overlay',
    },
    // central event bus
    eventShow: {
      type: String,
      default: 'show-full-loading',
    },
    eventHide: {
      type: String,
      default: 'hide-full-loading',
    },
  },
  data() {
    return {
      showing: false,
    }
  },
  watch: {
    show(val) {
      this.showing = val
    },
  },
  created() {
    eventBus.$on('changeLoadingState', (state) => {
     // console.log('state', state)
      this.showing = state
    })
  },
  mounted() {
    // If event bus, register methods.
    // if (this.eventBus) {
    //   this.registerBusMethods()
    // }
  },
  beforeDestroy() {
    eventBus.$off('changeLoadingState')
  },
  methods: {
    showMe() {
      this.showing = true
    },
    hideMe() {
      this.showing = false
    },
    // Register eventBus methods.
    // registerBusMethods() {
    //   this.eventBus.$on(this.eventShow, this.showMe)
    //   this.eventBus.$on(this.eventHide, this.hideMe)
    // },
  },
}
</script>
<style scoped>
.white-overlay {
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 9999;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  position: fixed;
  margin: 0;
}

.loader-wrapper {
  position: absolute;
  display: inline-block;
  right: 40%;
  bottom: 50%;
}

.text-position {
  position: relative;
  top: 15px;
  right: 8px;
}

*,
*:before,
*:after {
  box-sizing: border-box;
}

.wrapper {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 40px;
  font-size: 0;
}

/*text laoding*/
#fountainTextG {
  width: 234px;
  margin: auto;
}

.fountainTextG {
  color: rgb(0, 0, 0);
  font-family: Arial;
  font-size: 24px;
  text-decoration: none;
  font-weight: normal;
  font-style: normal;
  float: left;
  animation-name: bounce_fountainTextG;
  -o-animation-name: bounce_fountainTextG;
  -ms-animation-name: bounce_fountainTextG;
  -webkit-animation-name: bounce_fountainTextG;
  -moz-animation-name: bounce_fountainTextG;
  animation-duration: 2.09s;
  -o-animation-duration: 2.09s;
  -ms-animation-duration: 2.09s;
  -webkit-animation-duration: 2.09s;
  -moz-animation-duration: 2.09s;
  animation-iteration-count: infinite;
  -o-animation-iteration-count: infinite;
  -ms-animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  animation-direction: normal;
  -o-animation-direction: normal;
  -ms-animation-direction: normal;
  -webkit-animation-direction: normal;
  -moz-animation-direction: normal;
  transform: scale(0.5);
  -o-transform: scale(0.5);
  -ms-transform: scale(0.5);
  -webkit-transform: scale(0.5);
  -moz-transform: scale(0.5);
}

#fountainTextG_1 {
  animation-delay: 0.75s;
  -o-animation-delay: 0.75s;
  -ms-animation-delay: 0.75s;
  -webkit-animation-delay: 0.75s;
  -moz-animation-delay: 0.75s;
}

#fountainTextG_2 {
  animation-delay: 0.9s;
  -o-animation-delay: 0.9s;
  -ms-animation-delay: 0.9s;
  -webkit-animation-delay: 0.9s;
  -moz-animation-delay: 0.9s;
}

#fountainTextG_3 {
  animation-delay: 1.05s;
  -o-animation-delay: 1.05s;
  -ms-animation-delay: 1.05s;
  -webkit-animation-delay: 1.05s;
  -moz-animation-delay: 1.05s;
}

#fountainTextG_4 {
  animation-delay: 1.2s;
  -o-animation-delay: 1.2s;
  -ms-animation-delay: 1.2s;
  -webkit-animation-delay: 1.2s;
  -moz-animation-delay: 1.2s;
}

#fountainTextG_5 {
  animation-delay: 1.35s;
  -o-animation-delay: 1.35s;
  -ms-animation-delay: 1.35s;
  -webkit-animation-delay: 1.35s;
  -moz-animation-delay: 1.35s;
}

#fountainTextG_6 {
  animation-delay: 1.5s;
  -o-animation-delay: 1.5s;
  -ms-animation-delay: 1.5s;
  -webkit-animation-delay: 1.5s;
  -moz-animation-delay: 1.5s;
}

#fountainTextG_7 {
  animation-delay: 1.64s;
  -o-animation-delay: 1.64s;
  -ms-animation-delay: 1.64s;
  -webkit-animation-delay: 1.64s;
  -moz-animation-delay: 1.64s;
}

@keyframes bounce_fountainTextG {
  0% {
    transform: scale(1);
    color: rgb(0, 0, 0);
  }

  100% {
    transform: scale(0.5);
    color: rgb(255, 255, 255);
  }
}

@-o-keyframes bounce_fountainTextG {
  0% {
    -o-transform: scale(1);
    color: rgb(0, 0, 0);
  }

  100% {
    -o-transform: scale(0.5);
    color: rgb(255, 255, 255);
  }
}

@-ms-keyframes bounce_fountainTextG {
  0% {
    -ms-transform: scale(1);
    color: rgb(0, 0, 0);
  }

  100% {
    -ms-transform: scale(0.5);
    color: rgb(255, 255, 255);
  }
}

@-webkit-keyframes bounce_fountainTextG {
  0% {
    -webkit-transform: scale(1);
    color: rgb(0, 0, 0);
  }

  100% {
    -webkit-transform: scale(0.5);
    color: rgb(255, 255, 255);
  }
}

@-moz-keyframes bounce_fountainTextG {
  0% {
    -moz-transform: scale(1);
    color: rgb(0, 0, 0);
  }

  100% {
    -moz-transform: scale(0.5);
    color: rgb(255, 255, 255);
  }
}
</style>
